import React, { Component } from "react";
import { Field, Form, withFormik } from "formik";
import * as Yup from "yup";
import { yearRegex } from "../../../../../globals.js";
import Aux from "../../../../../hoc/Auxilary";
import SelectionFields from "../../../../../hoc/UI/SelectionFields/SelectionFields";
import { Button } from "rsuite";


class DevP3AlternativeForm extends Component {
  render() {
    const role = localStorage.getItem("project_role");
    const validAndHandle = (func, values) => {
      this.props.validateForm().then(errors => {
        console.log("errors", errors);

        if (Object.keys(errors).length !== 0) {
            this.props.setFieldTouched("p3_type_id", true);
            this.props.setFieldTouched("p3_start_year", true);
            this.props.setFieldTouched("p3_complete_year", true);
            this.props.setFieldTouched("availability_payment_under_p3", true);
            this.props.setFieldTouched("concession_fee_under_p3", true);
            console.log("cannot submit! Validation failed", errors);
        } else {
          this.props.values.project_id = this.props.currentProjectID;
          func(values);
          this.props.toggleSmallModalHandler();
        }
      });
    };

    let buttonGroup = null;
    if (this.props.values.data_status_id === 1) {
      buttonGroup = (
        <Aux>
          <Button
              color={"blue"}
            type="button"
            onClick={() => {
              validAndHandle(this.props.methods.updateDraft, this.props.values);
            }}
          >
            Save Updates
          </Button>
          <Button
              className={"ml-2"}
              color={"blue"}
            type="button"
            onClick={() => {
              validAndHandle(
                this.props.methods.updateDraftAndSubmit,
                this.props.values
              );
            }}
          >
            Submit for Approval
          </Button>
          <Button
              color={"red"}
              className={"ml-2"}
              type="button"
              onClick={this.props.handleReset}>
            Reset
          </Button>
        </Aux>
      );
    } else if (this.props.values.data_status_id === 2) {
      if (role === "ROLE_MEMBER" || role === "ROLE_AUDITOR") {
        buttonGroup = (
          <Button
              color={"blue"}
      type="button"
            onClick={() => {
              validAndHandle(this.props.methods.audit, this.props.values);
            }}
          >
            Audit
          </Button>
        );
      }
    } else if (this.props.values.data_status_id === 3) {
      if (role === "ROLE_MEMBER") {
        buttonGroup = (
          <Button
              color={"blue"}
              type="button"
            onClick={() => {
              validAndHandle(this.props.methods.update, this.props.values);
            }}
          >
            Update
          </Button>
        );
      }
    } else {
      buttonGroup = (
        <Aux>
          <Button
              color={"blue"}
            type="button"
            onClick={() => {
              validAndHandle(this.props.methods.draft, this.props.values);
            }}
          >
            Save as Draft
          </Button>
          <Button
              color={"blue"}
              className={"ml-2"}
              type="button"
            onClick={() => {
              validAndHandle(this.props.methods.submit, this.props.values);
            }}
          >
            Submit
          </Button>
          <Button type="button" onClick={this.props.handleReset} className={"ml-2"} color={"red"}>
            Reset
          </Button>
        </Aux>
      );
    }

    return (
      <Form>
        <fieldset
          disabled={this.props.disabled}
        >
            <small className={"d-block col-12"}><span style={{color:"red"}}>*</span> required</small>
            <label className="col-3 pl-2" style={this.props.errors.availability_payment_under_p3 && this.props.touched.availability_payment_under_p3 && {color: "red"}}>
            Availability Payment Under P3
                        <Field
                className="form-control"
              name={"availability_payment_under_p3"}
              value={this.props.values.availability_payment_under_p3 || null}
            />
          </label>
            {this.props.errors.availability_payment_under_p3 && this.props.touched.availability_payment_under_p3 && (
                <small className="text-danger">{this.props.errors.availability_payment_under_p3}</small>
            )}

          <label className="col-3 pl-2" style={this.props.errors.concession_fee_under_p3 && this.props.touched.concession_fee_under_p3 && {color: "red"}}>
            Concession Fee Under P3
                        <Field
                className="form-control"
              name={"concession_fee_under_p3"}
              value={this.props.values.concession_fee_under_p3 || null}
            />
          </label>
            {this.props.errors.concession_fee_under_p3 && this.props.touched.concession_fee_under_p3 && (
                <small className="text-danger">{this.props.errors.concession_fee_under_p3}</small>
            )}

          <label className="col-3 pl-2">
            Discount Rate
                        <Field
                className="form-control"
              name={"discount_rate"}
              value={this.props.values.discount_rate || ""}
            />
          </label>

          <label className="col-3 pl-2">
            Estimated Cost Type
                        <Field
                className="form-control"
              name={"estimated_cost_type"}
              value={this.props.values.estimated_cost_type || ""}
            />
          </label>

          <label className="col-3 pl-2">
            Other Delivery Method Evaluated
                        <Field
                className="form-control"
              name={"other_delivery_method_evaluated"}
              value={this.props.values.other_delivery_method_evaluated || ""}
            />
          </label>

          <label
              style={this.props.errors.p3_complete_year && this.props.touched.p3_complete_year && {color: "red"}}
              className="col-3 pl-2">
            P3 Complete Year
                        <Field
                            style={this.props.errors.p3_complete_year && this.props.touched.p3_complete_year && {borderColor: "red"}}
                            className="form-control"
              name={"p3_complete_year"}
              value={this.props.values.p3_complete_year || null}
            />
              {this.props.errors.p3_complete_year && this.props.touched.p3_complete_year && (
                  <small className="text-danger">{this.props.errors.p3_complete_year}</small>
              )}

          </label>


            <label
                style={this.props.errors.p3_start_year && this.props.touched.p3_start_year && {color: "red"}}
                className="col-3 pl-2">
            P3 Start Year
                        <Field
                            style={this.props.errors.p3_start_year && this.props.touched.p3_start_year && {borderColor: "red"}}
                            className="form-control"
              name={"p3_start_year"}
              value={this.props.values.p3_start_year || null}
            />
                {this.props.errors.p3_start_year && this.props.touched.p3_start_year && (
                    <small className="text-danger">{this.props.errors.p3_start_year}</small>
                )}
          </label>


            <SelectionFields
                showError={this.props.errors.p3_type_id && this.props.touched.p3_type_id}
                size="col-3 pl-2"
                id={"p3_type_id"}
                url={"p3_type_lkp"}
                showElem={"name"}
                label={"P3 Type"}
                value={this.props.values["p3_type_id"] || "default"}
                isRequired={true}
                errorMessage=              {this.props.errors.p3_type_id && this.props.touched.p3_type_id && (
                <small className="text-danger">{this.props.errors.p3_type_id}</small>
            )}

            />








          <label className="col-3 pl-2">
            Public Milestone Payment
                        <Field
                className="form-control"
              name={"public_milestone_payment"}
              value={this.props.values.public_milestone_payment || ""}
            />
          </label>

          <label className="col-3 pl-2">
            Risk Value Under P3
                        <Field
                className="form-control"
              name={"risk_value_under_p3"}
              value={this.props.values.risk_value_under_p3 || ""}
            />
          </label>

          <label className="col-6 pl-2 d-block">
            Notes
                        <Field
                            component={"textarea"}
                            className="form-control" name={"notes"} value={this.props.values.notes || ""} />
          </label>
        </fieldset>

          {this.props.disabled ? null : buttonGroup}
        <Button className="ml-2" type="button" onClick={this.props.toggleSmallModalHandler}>
          Cancel
        </Button>
      </Form>
    );
  }
}

var devP3AlternativeFormSchema = Yup.object().shape({
    p3_complete_year: Yup.string().nullable().matches(yearRegex, "Invalid year").typeError("Must be a year type"),
    p3_start_year: Yup.string().nullable().matches(yearRegex, "Invalid year").typeError("Must be a year type"),
    p3_type_id: Yup.string().required(),
    availability_payment_under_p3: Yup.number().nullable().typeError("Invalid number"),
    concession_fee_under_p3: Yup.number().nullable().typeError("Invalid number"),
});

export default withFormik({
  validationSchema: devP3AlternativeFormSchema,

  mapPropsToValues({ currentDevP3AlternativeCost }) {
    return {
      ...currentDevP3AlternativeCost
    };
  }
})(DevP3AlternativeForm);
